var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "100px",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.019608%,30.588235%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 26.453125 128.878906 L 15.648438 7.648438 L 134.351562 7.648438 L 123.53125 128.890625 L 74.972656 142.351562 Z M 26.453125 128.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,40%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 75 17.558594 L 75 132.054688 L 114.265625 121.167969 L 123.519531 17.558594 Z M 75 17.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 37.761719 32.429688 L 41.769531 77.390625 L 93.304688 77.390625 L 91.574219 96.679688 L 74.980469 101.164062 L 58.417969 96.683594 L 57.3125 84.300781 L 42.386719 84.300781 L 44.519531 108.171875 L 74.976562 116.632812 L 105.472656 108.171875 L 109.558594 62.523438 L 55.367188 62.523438 L 54.007812 47.296875 L 110.90625 47.296875 L 112.238281 32.429688 Z M 37.761719 32.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 75 32.429688 L 37.761719 32.429688 L 41.769531 77.390625 L 75 77.390625 L 75 62.523438 L 55.367188 62.523438 L 54.007812 47.296875 L 75 47.296875 Z M 75 32.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 75 101.15625 L 74.980469 101.164062 L 58.417969 96.683594 L 57.3125 84.300781 L 42.386719 84.300781 L 44.519531 108.171875 L 74.976562 116.632812 L 75 116.625 Z M 75 101.15625 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.447ead916e7ec9697679cb1df114162e.svg";
export { ForwardRef as ReactComponent };